import React from "react";
import videoBanner from "../../img/video/videobanner.mp4";
import { Play } from "lucide-react";

export default function VideoCity() {
  return (
    <section className="max-w-[1350px] mx-auto px-2 mt-16">

      <div className="relative w-full h-[600px] rounded-md overflow-hidden shadow-md">

        {/* VIDEO */}
        <video
          src={videoBanner}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/35"></div>

        {/* TEXTO */}
        <div className="absolute bottom-8 left-8 text-white">
          <h3 className="text-xl font-semibold">
            Agende agora sua visita
          </h3>

          <p className="text-sm opacity-90 mt-1">
            Clique aqui e descubra nossas lojas físicas
          </p>
        </div>

      </div>

    </section>
  );
}